import { ApiResult, cata } from 'data/ApiResult'

import { AppThunk } from 'redux/store'

import { showError } from './globalError'

export const handleApiError = (result: ApiResult<unknown>): AppThunk => async dispatch => {
    dispatch(showError(`We're experiencing some connectivity issues. Please refresh the page to try again`))

    cata(result, {
        HttpError: error => {
            if (error.response?.status === 404) window.location.replace('/')
        },
        _: console.error,
    })
}
